import React, { useRef, useEffect, useReducer, Fragment } from 'react';
import lottie, { AnimationItem } from 'lottie-web/build/player/lottie_light';
import { Icon } from 'sunzi-components';
import { I18n } from 'sunzi-utils';
import { ReactComponent as TipCircle } from '../assets/tip-circle.svg';
import animationJson from '../assets/tutorial.json';
import styles from '../index.less';

interface TutorialProps {
  /** 图片坐标 */
  imageOffset: ({ left: number; top: number })[];
  /** 用户图片 */
  images: (string | null)[];
  /** 确认回调 */
  onConfirm: () => void;
}

const Tutorial: React.FC<TutorialProps> = ({ imageOffset, images, onConfirm }) => {

  /** 挂载 dom */
  const _element = useRef<HTMLDivElement>(null);
  /** 动画实例 */
  const lottieAnimation = useRef<AnimationItem>();
  /** forceUpdate */
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  useEffect(() => {
    if (_element.current) {
      lottieAnimation.current = lottie.loadAnimation({
        container: _element.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationJson,
      });
      forceUpdate();
    }
  }, []);

  return (
    <div className={styles.tutorial}>
      <div
        style={{
          '--left-first': `${imageOffset[0]?.left}px`,
          '--top-first': `${imageOffset[0]?.top}px`,
          '--left-second': `${imageOffset[1]?.left}px`,
          '--top-second': `${imageOffset[1]?.top}px`,
        } as React.CSSProperties}
        ref={_element}
        className={styles.animation}
        onAnimationIteration={() => lottieAnimation.current?.goToAndPlay(0)}
      />
      {imageOffset[0] &&
        <Fragment>
          <div
            style={{
              backgroundImage: `url(${images[1] ?? require('../assets/default-image.jpg')})`,
              '--left-first': `${imageOffset[0].left}px`,
              '--top-first': `${imageOffset[0].top}px`,
              '--left-second': `${imageOffset[1].left}px`,
              '--top-second': `${imageOffset[1].top}px`,
            } as React.CSSProperties}
            className={styles.firstImage}
          />
          <div
            style={{
              backgroundImage: `url(${images[0]}`,
              '--left-first': `${imageOffset[0].left}px`,
              '--top-first': `${imageOffset[0].top}px`,
              '--left-second': `${imageOffset[1].left}px`,
              '--top-second': `${imageOffset[1].top}px`,
            } as React.CSSProperties}
            className={styles.secondImage}
          />
        </Fragment>
      }
      <div className={styles.tutorialTip}>
        <div className={styles.title}>
          <Icon className={styles.iconWrapper}>
            <TipCircle />
          </Icon>
          <div className={styles.text}>{I18n.format('tutorial.title')}</div>
        </div>
        <div
          className={styles.confirm}
          onClick={onConfirm}
        >
          {I18n.format('tutorial.confirm')}
        </div>
      </div>
    </div>
  );
}

export default Tutorial;
